import $axios from "../../api/axios";

function signInApi({ params, callback }) {
  $axios
    .post("/api/user/login", params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function signOutApi({ callback }) {
  $axios
    .post("/api/user/logout")
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function createApi({ params, callback }) {
  $axios
    .put("/api/updatePassword/" + params.password)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function forgotApi({ params, callback }) {
  $axios
    .post("/api/email/user/password", params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getUrlApi({ callback }) {
  $axios
    .post("/api/setupList")
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function updateApi({ params, callback }) {
  $axios
    .post("/api/email/user/renewPassword", params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  signInApi,
  createApi,
  getUrlApi,
  forgotApi,
  updateApi,
  signOutApi
};



// WEBPACK FOOTER //
// ./src/api/login/login.js